import { GiftRuleType } from "./giftRuleType";

export class GiftRule {

  id: string | undefined;
  type: GiftRuleType | undefined;
  groupId: number | undefined;
  fuelIds: string[] | undefined;
  valueType: string | undefined;
  value: number | undefined;
  quantity: number | undefined;
  stationIds: string[] | undefined;
  startDate: string | undefined;
  endDate: string | undefined;
  clubeCertoCheckPeriodDays: number | null | undefined;
  code: string | null | undefined;
  bolaoId: string | null | undefined;
  bolaoName: string | null | undefined; // display-only (preenchido após selecionar)
  roletaId: string | null | undefined; // Para tipo 'roleta_prize' - roleta vinculada
  roletaName: string | null | undefined; // display-only (preenchido após selecionar)
  useManualCode: boolean | undefined;
  useQrCode: boolean | undefined;
  requireLocation: boolean | undefined;
  locationCoordinates: Array<{ latitude: number; longitude: number }> | null | undefined;

  static createGiftRule(value: Partial<GiftRule>) {
    const giftRule: Partial<GiftRule> = {
      type: value.type,
      groupId: value.groupId,
      fuelIds: value.fuelIds ?? (value as any).giftRuleFuels?.map((grf: any) => grf.fuelId) ?? [],
      valueType: value.valueType,
      value: value.value,
      quantity: value.quantity,
      startDate: value.startDate,
      endDate: value.endDate,
      stationIds: value.stationIds,
      clubeCertoCheckPeriodDays: value.clubeCertoCheckPeriodDays,
      code: value.code,
      bolaoId: value.bolaoId,
      bolaoName: value.bolaoName,
      roletaId: value.roletaId,
      roletaName: value.roletaName,
      useManualCode: value.useManualCode,
      useQrCode: value.useQrCode,
      requireLocation: value.requireLocation,
      locationCoordinates: value.locationCoordinates,
    };

    return giftRule;
  }

  constructor(init?: Partial<GiftRule>) {
    Object.assign(this, init);
  }
}